import axios from "axios";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

export const createFormApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.hearnuFormBase,
    method: "POST",
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const fetchFormApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.hearnuFormBase,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const downloadFormApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.downloadFormCsv,
    method: "get",
    headers: getHeaders(),
    params,
    responseType: "blob", // THIS IS CRUCIAL
  })
    .then((response) => response.data)
    .catch((err) => {
      throw err.response?.data || "Download failed";
    });

  return callResponse;
};
